import { render } from "./ServiceDetailsMobile.component.vue?vue&type=template&id=08e781d8"
import script from "./ServiceDetailsMobile.component.vue?vue&type=script&lang=js"
export * from "./ServiceDetailsMobile.component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ASIP-Sante/g1/shared/santefr/web/modules/custom/sante_vuejs/vue-core/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/phoneBook/servicesContent/servicesContentComponents/ServiceDetailsMobile.component.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "08e781d8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('08e781d8', __exports__)) {
    console.log('reload')
    api.reload('08e781d8', __exports__)
  }
  
  module.hot.accept("./ServiceDetailsMobile.component.vue?vue&type=template&id=08e781d8", () => {
    console.log('re-render')
    api.rerender('08e781d8', render)
  })

}


export default __exports__